import { useQuery } from '@tanstack/react-query';
import { getUiConfig } from '@/api/frontend';
import config from '@/config/env';
import { resolveUiConfig } from '@/config/ui';
import type { UiConfig } from '@/types/ui';

interface UseUiConfigResult {
  config: UiConfig;
  debugLoggingEnabled: boolean;
  isLoading: boolean;
  error: unknown;
}

export function useUiConfig(): UseUiConfigResult {
  const query = useQuery({
    queryKey: ['ui-config'],
    queryFn: getUiConfig,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const allowFallback = config.isDevelopment || query.isLoading;
  let resolved: UiConfig;
  let configError: unknown = query.error;
  try {
    resolved = resolveUiConfig(query.data, allowFallback);
  } catch (err) {
    configError = err;
    if (!config.isDevelopment) {
      throw err;
    }
    resolved = resolveUiConfig(null, true);
  }
  const debugLoggingEnabled =
    config.isDevelopment && Boolean(resolved.debug_logging_enabled);

  return {
    config: resolved,
    debugLoggingEnabled,
    isLoading: query.isLoading,
    error: configError,
  };
}

export default useUiConfig;
